import React, { useState, useEffect, useRef } from "react";
import { Button, Modal, FormFieldSet, showToast } from "../../../components";
import { useSelector } from "react-redux";
import { SmartTooltip } from "../../../components"; //  add this

import {
  deletePostConfigApi,
  handlePostConfigGetAllApi,
  handlePostConfigSaveApi,
} from "../../../redux/slices/ats/benchSales/benchSalesApi";
import { usePagination } from "../../../hooks";
import { TableAdv } from "../../../components";
// import { SmartTooltip } from "../../../components/index.js";
export default function PostConfigs() {
  const [open, setOpen] = useState(false);
  const userId = useSelector((state) => state.auth?.user?.data?.uiid);
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );
  const [loading, setLoading] = useState(false);
  const [postConfigOpen, setPostConfigOpen] = useState(false);
  const [selectedPostConfigId, setselectedPostConfigId] = useState(null);
  const textRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const [form, setForm] = useState({
    booleanSearch: "",
    emailLimit: "",
    duration: "past-month",
    excludeDesignation: "",
    excludePostText: "",
    displayName: "",
  });
  const [postConfig, setPostConfig] = useState([]);
  const [showFullBoolean, setShowFullBoolean] = useState(false);

  const handlePostConfigeDelete = async (id) => {
    try {
      const response = await deletePostConfigApi({
        coll: "PostConfig",
        uiid: id,
      });

      if (response.success) {
        showToast("Configuration deleted successfully!", "success");
        getAllPostConfig(); // Refresh the list after deletion
      } else {
        showToast("Failed to delete configuration. Please try again.", "error");
      }
    } catch (error) {
      console.error("Error deleting post config:", error);
    }
  };

  const postTableData = postConfig?.data?.map((item) => {
    return {
      id: item?._id,
      uiid: item?.uiid,
      booleanSearches: item?.booleanSearches?.join(", "),
      duration: item?.duration,
      emailLimit: item?.emailLimit,
      exclusions:
        item?.exclusions?.designationPhrases?.join(", ") +
        " || " +
        item?.exclusions?.postPhrases?.join(", "),
      addedBy: item?.addedBy,
      displayName: form.displayName || "",
      displayName: item?.displayName,
      createdAt: item?.createdAt,
    };
  });
  console.log("  postTableData:", postTableData);

  const selectedPostConfig = postTableData?.find(
    (row) => row.id === selectedPostConfigId,
  );

  const columnPostConfig = [
    { key: "displayName", label: "Display Name" },
    {
      key: "booleanSearches",
      label: "Boolean Searches",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.booleanSearches}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.booleanSearches || "-"}</div>
        </SmartTooltip>
      ),
    },
    { key: "duration", label: "Duration" },
    { key: "emailLimit", label: "Emails to Extract" },
    {
      key: "exclusions",
      label: "Exclusions",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.exclusions}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.exclusions || "-"}</div>
        </SmartTooltip>
      ),
    },
    // { key: "addedBy", label: "Added By" },
    // { key: "createdAt", label: "Created At" },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex gap-2">
          <SmartTooltip
            description="View Post Config"
            size="xs"
            color="black"
            noicon
            portal={true}
          >
            <Button
              type="icon"
              icon="visibility"
              variant="text"
              size="xs"
              color="dark"
              //  onClick={() => setOpenViewModal(true)} // open 2nd modal
              onClick={() => {
                setPostConfigOpen(true);
                setselectedPostConfigId(row.id);
                // setCandidateDetails(row);
                // setVisibilltyProp(true);
              }}
            />
          </SmartTooltip>
          <SmartTooltip
            description="View Post Config"
            size="xs"
            color="black"
            noicon
            portal={true}
          >
            <Button
              type="delete"
              icon="delete"
              variant="text"
              size="xs"
              color="dark"
              //  onClick={() => setOpenViewModal(true)} // open 2nd modal
              onClick={() => {
                handlePostConfigeDelete(row.uiid);
                // setCandidateDetails(row);
                // setVisibilltyProp(true);
              }}
            />
          </SmartTooltip>
          {/* <SmartTooltip
            description="Edit Candidate"
            size="xs"
            color="black"
            noicon
            portal={true}
          >
            <Button
              type="icon"
              icon={navLoading ? "sync" : "edit"}
              variant="text"
              size="xs"
              color="dark"
              //  onClick={() => setOpenViewModal(true)} // open 2nd modal
              onClick={() => handleEditCandidate(row)}
              disabled={navLoading}
            />
          </SmartTooltip> */}
        </div>
      ),
    },
  ];

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const buildPayload = () => {
    // Boolean searches (multi-line)
    const searches = form.booleanSearch
      ?.split("\n")
      .map((s) => s.trim())
      .filter(Boolean)
      .slice(0, 15);

    if (!searches.length) {
      // alert("Enter at least one boolean search");
      showToast("Enter at least one boolean search", "error");
      return null;
    }

    // Exclusions
    const excludeDesignation = form.excludeDesignation
      ?.split(",")
      .map((s) => s.trim())
      .filter(Boolean);

    const excludePostText = form.excludePostText
      ?.split(",")
      .map((s) => s.trim())
      .filter(Boolean);

    return {
      booleanSearches: searches,
      duration: form.duration || "past-month",
      emailLimit: parseInt(form.emailLimit) || 10,
      exclusions: {
        designationPhrases: excludeDesignation,
        postPhrases: excludePostText,
      },
      addedBy: userId,
      displayName: form.displayName,
    };
  };

  const handleSave = async () => {
    const payload = buildPayload();
    if (!payload) return;

    console.log("FINAL PAYLOAD:", payload);

    try {
      const response = await handlePostConfigSaveApi({
        ...payload,
        coll: "PostConfig",
      });

      if (response.success) {
        showToast("Configuration saved successfully!", "success");
      } else {
        showToast("Failed to save configuration. Please try again.", "error");
      }
      console.log("Response:", response);
      // await window.scraper.startPostScraping(payload);

      setOpen(false);
    } catch (err) {
      console.error(err);
    } finally {
      getAllPostConfig();
    }
  };

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowing(
        textRef.current.scrollHeight > textRef.current.clientHeight,
      );
    }
  }, [selectedPostConfig]);

  useEffect(() => {
    getAllPostConfig();
  }, [page, limit]);

  const getAllPostConfig = async () => {
    try {
      const response = await handlePostConfigGetAllApi({
        coll: "PostConfig",
        page: page,
        limit: limit,
      });
      if (response.success) {
        setPostConfig(response.data);
      } else {
        showToast("Failed to fetch configuration. Please try again.", "error");
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <div>
      {/* Button */}
      <div className="flex items-center justify-end mt-2">
        <Button
          title="Add Automation"
          icon="add"
          onClick={() => setOpen(true)}
        />
      </div>
      <div>
        <TableAdv
          showSlNo
          columns={columnPostConfig}
          rows={postTableData}
          // totalCount={totalCount}
          tableId={"postconfigtable"}
          isLoading={loading}
          // page={page}
          // limit={limit}
          page={page}
          limit={limit}
          isPagination={true}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          toolbarLeft={
            {
              // add: toolbarAdd,
            }
          }
          toolbarRight={{
            search: false,
            fullScreen: true,
            // add: toolbarRightAdd,
          }}
        />
      </div>

      {/* Modal */}
      <Modal
        isOpen={open}
        onClose={() => setOpen(false)}
        title="Add Automation"
        width="max-w-2xl"
        titleColor="primary"
      >
        <div className="flex flex-col gap-4">
          <FormFieldSet
            title="Display Name"
            type="text"
            placeholder="Enter display name"
            value={form.displayName}
            onChange={(v) => handleChange("displayName", v)}
          />
          {/* Boolean Search */}
          <FormFieldSet
            title="Boolean Search"
            type="textArea"
            rows={5}
            placeholder={`Example:
("Java Developer" OR "Backend Developer")
("Python Developer") AND Django`}
            value={form.booleanSearch}
            onChange={(v) => handleChange("booleanSearch", v)}
            maxLength={1000}
          />

          {/* Emails */}
          <FormFieldSet
            title="Emails to Extract"
            type="number"
            placeholder="10"
            value={form.emailLimit}
            onChange={(v) => handleChange("emailLimit", v)}
            min={10}
          />

          {/* Duration */}
          <FormFieldSet
            title="Duration"
            type="select"
            options={[
              { label: "Past 24 Hours", value: "past-24h" },
              { label: "Past Week", value: "past-week" },
              { label: "Past Month", value: "past-month" },
            ]}
            value={form.duration}
            onChange={(v) => handleChange("duration", v)}
          />

          {/* Exclude Designation */}
          <FormFieldSet
            title="Exclude Designation"
            type="textArea"
            rows={1}
            placeholder="Developer, Tester"
            value={form.excludeDesignation}
            onChange={(v) => handleChange("excludeDesignation", v)}
            maxLength={500}
          />

          {/* Exclude Post Text */}
          <FormFieldSet
            title="Exclude Post Text"
            type="textArea"
            rows={1}
            placeholder="Bench, Hiring Freeze"
            value={form.excludePostText}
            onChange={(v) => handleChange("excludePostText", v)}
            maxLength={500}
          />

          {/* Actions */}
          <div className="flex justify-end gap-2">
            <Button
              title="Cancel"
              variant="outlined"
              onClick={() => setOpen(false)}
            />
            <Button title="Save" onClick={handleSave} />
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={postConfigOpen}
        onClose={() => setPostConfigOpen(false)}
        title="View Post Config"
        width="max-w-2xl"
        titleColor="primary"
      >
        <div className="space-y-3 text-sm">
          <div>
            <strong>Boolean Searches:</strong>
            {/* {console.log("selectedPostConfig?.booleanSearches", selectedPostConfig?.booleanSearches)}
            <p>{selectedPostConfig?.booleanSearches || "-"}</p> */}
            <p
              ref={textRef}
              className={`${showFullBoolean ? "" : "line-clamp-2"} break-words`}
            >
              {selectedPostConfig?.booleanSearches || "-"}
            </p>

            {isOverflowing && (
              <button
                className="text-blue-500 text-xs mt-1"
                onClick={() => setShowFullBoolean((prev) => !prev)}
              >
                {showFullBoolean ? "Show less" : "Show more"}
              </button>
            )}
          </div>

          <div>
            <strong>Duration:</strong>
            <p>{selectedPostConfig?.duration || "-"}</p>
          </div>

          <div>
            <strong>Email Limit:</strong>
            <p>{selectedPostConfig?.emailLimit || "-"}</p>
          </div>

          <div>
            <strong>Exclusions:</strong>
            <p>{selectedPostConfig?.exclusions || "-"}</p>
          </div>

          {/* <div>
            <strong>Added By:</strong>
            <p>{selectedPostConfig?.addedBy || "-"}</p>
          </div> */}

          <div>
            <strong>Created At:</strong>
            <p>
              {selectedPostConfig?.createdAt
                ? new Date(selectedPostConfig.createdAt).toLocaleString()
                : "-"}
            </p>
          </div>
        </div>
      </Modal>
    </div>
  );
}
